import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { loginAdmin } from "../../../Redux/Auth/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEyeSlash } from "react-icons/fa6";
import Logo from "../../../Assets/Logo.png";
import { FaRegEye } from "react-icons/fa6";
import { useNavigate } from "react-router";
import styles from "./Login.module.scss";
import { useState } from "react";

function Login() {
  const dispatch = useDispatch<AppDispatch>();
  const { adminLoginLoading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const loginHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (!adminLoginLoading) {
      if (email && password) {
        dispatch(loginAdmin({ email, password }, navigate));
      }
    }
  };

  return (
    <div className={styles.mainContainer}>
      {/* Right Container - Login form */}
      <div className={styles.loginContainer}>
        <div className={styles.loginFormContainer}>
          {/* Logo */}
          <div className={styles.logoContainer}>
            <img src={Logo} alt="Logo" className={styles.logo} />
          </div>

          {/* Login Form */}
          <form
            className={`${styles.loginForm} ${adminLoginLoading ? styles.submitting : ""}`}
            onSubmit={loginHandler}
          >
            {/* Email Input */}
            <div className={styles.inputContainer}>
              <p className={styles.label}>Email</p>
              <input
                type="text"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="on"
              />
            </div>

            {/* Password Input */}
            <div className={styles.inputContainer}>
              <p className={styles.label}>Password</p>
              <div className={styles.passwordInputContainer}>
                <input
                  type={showPassword ? "text" : "password"}
                  className={styles.input}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className={styles.showPasswordButton}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FaRegEyeSlash className={styles.icon} />
                  ) : (
                    <FaRegEye className={styles.icon} />
                  )}
                </button>
              </div>
            </div>

            {/* Login Button */}

            {adminLoginLoading && <Loading />}

            {/* Login Button */}
            <div className={styles.loginButtonContainer}>
              <button type="submit" className={styles.loginBtn}>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
